import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=4a6b0862&scoped=true"
import script from "./WizardStep.vue?vue&type=script&lang=js"
export * from "./WizardStep.vue?vue&type=script&lang=js"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=4a6b0862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b0862",
  null
  
)

export default component.exports